import * as React from 'react';
import {observer} from "mobx-react"
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import '../index.css';



type hoursProps = {
    hours: any
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }),
);



@observer
export default class OpeningHours extends React.Component<hoursProps> {



    render()
    {

        return (
            <div>
                <div className="header_openHours">
                    <div className="header_openHours_text">Öffnungzeiten</div>
                    <div className="header_openHours_body">Gerne begrüßen wir Sie zu den unten angeführten Zeiten in unseren Räumlichkeiten</div>
                </div>
                <div className="root_grid" style={{marginTop : "10%"}}>
                    <Grid alignItems="stretch" container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className="paper_grid"><div className="openingHours_Header">Büro / Ersatzteillager / Werkstatt</div></Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Montag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 16:30</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Dienstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 16:30</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Mittwoch</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 16:30</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Donnerstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 16:30</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Freitag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 16:30</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Samstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">geschlossen</Paper>
                        </Grid>


                    </Grid>
                </div>
                <div className="root_grid">
                    <Grid alignItems="stretch" container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className="paper_grid"><div className="openingHours_Header">Verkauf – Neu- und Gebrauchtmaschinen</div></Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Montag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15- 17:00</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Dienstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15 - 17:00</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Mittwoch</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15 - 17:00</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Donnerstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15 - 17:00</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Freitag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">07:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">13:15 - 17:00</Paper>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Paper className="paper_grid"><div className="grid_text_inside">Samstag</div></Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">08:30 - 12:00</Paper>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Paper className="paper_grid">geschlossen</Paper>
                        </Grid>


                    </Grid>
                </div>
            </div>
        );

    }


}


